<template>
  <input ref="inputRef" type="text" class="form-control" />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';
import { watch, computed } from 'vue';
import { languages } from '../../main';

export default {
  name: 'CurrencyInput',
  props: {
    value: Number | String,
    options: Object,
  },
  setup(props) {
    const locale = computed(() => {
      const code = self.app.$store.state.i18n.locale;
      return languages.find((lang) => lang.code === code)?.numberFormat;
    });

    const newOptions = {
      ...props.options,
      locale: locale.value || 'en-US',
      hideCurrencySymbolOnFocus: true,
      hideGroupingSeparatorOnFocus: true,
      autoDecimalDigits: false,
      useGrouping: true,
      accountingSign: false,
      allowNegative: false,
      currency: 'USD', // Default to USD if not provided
      currencyDisplay: 'hidden',
      hideNegligibleDecimalDigitsOnFocus: true,
      valueRange: {
        min: 0,
        max: 10000000000000,
      },
    };

    const { inputRef, setOptions, setValue } = useCurrencyInput(newOptions);

    // Watch for locale changes and reinitialize the currency input
    watch(
      locale,
      (newLocale) => {
        setOptions({
          ...newOptions,
          locale: newLocale || 'en-US',
          currencyDisplay: 'hidden',
        });
        // Re-set the value to trigger a re-render with new locale
        setValue(props.value);
      },
      { immediate: true },
    );

    // Watch for value changes
    watch(
      () => props.value,
      (value) => {
        setValue(value);
      },
    );

    return { inputRef };
  },
};
</script>
